import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
    title: {
        defaultMessage: 'Potential payments',
        id: 'iaso.payments.potentialPayments',
    },
    lots: {
        defaultMessage: 'Payments lots',
        id: 'iaso.payments.lots',
    },
    user: {
        id: 'iaso.label.user',
        defaultMessage: 'User',
    },
    userName: {
        defaultMessage: 'User name',
        id: 'iaso.label.userName',
    },
    firstName: {
        defaultMessage: 'First name',
        id: 'iaso.label.firstName',
    },
    lastName: {
        defaultMessage: 'Last name',
        id: 'iaso.label.lastName',
    },
    parent: {
        id: 'iaso.label.parent',
        defaultMessage: 'Parent',
    },
    forms: {
        defaultMessage: 'Forms',
        id: 'iaso.forms.title',
    },
    userRoles: {
        defaultMessage: 'User Roles',
        id: 'iaso.label.userRoles',
    },
    createdDateFrom: {
        id: 'iaso.label.createdDateFrom',
        defaultMessage: 'Creation date from',
    },
    createdDateTo: {
        id: 'iaso.label.createdDateTo',
        defaultMessage: 'Creation date to',
    },
    changes: {
        id: 'iaso.workflows.changes',
        defaultMessage: 'Changes',
    },
    createLot: {
        id: 'iaso.payments.createLot',
        defaultMessage: 'Create a new lot of payments',
    },
    save: {
        id: 'iaso.label.save',
        defaultMessage: 'Save',
    },
    cancel: {
        id: 'iaso.label.cancel',
        defaultMessage: 'Cancel',
    },
    edit: {
        defaultMessage: 'Edit',
        id: 'iaso.label.edit',
    },
    name: {
        defaultMessage: 'Name',
        id: 'iaso.label.name',
    },
    comment: {
        id: 'iaso.label.comment',
        defaultMessage: 'Comment',
    },
    created_by: {
        id: 'iaso.label.created_by',
        defaultMessage: 'Created by',
    },
    date: {
        defaultMessage: 'Date',
        id: 'iaso.label.date',
    },
    status: {
        id: 'iaso.forms.status',
        defaultMessage: 'Status',
    },
    created_at: {
        id: 'iaso.forms.created_at',
        defaultMessage: 'Created',
    },
    new: {
        defaultMessage: 'New',
        id: 'iaso.forms.newCap',
    },
    all: {
        id: 'iaso.forms.all',
        defaultMessage: 'All',
    },
    sent: {
        id: 'iaso.payments.sent',
        defaultMessage: 'Sent',
    },
    paid: {
        id: 'iaso.payments.paid',
        defaultMessage: 'Paid',
    },
    partially_paid: {
        id: 'iaso.payments.partially_paid',
        defaultMessage: 'Partially paid',
    },
    payments: {
        id: 'iaso.label.payments',
        defaultMessage: 'Payments',
    },
    actions: {
        defaultMessage: 'Action(s)',
        id: 'iaso.label.actions',
    },
    mark_as_sent: {
        defaultMessage: 'Mark as sent',
        id: 'iaso.payments.mark_as_sent',
    },
    download_payments: {
        defaultMessage: 'Download payments',
        id: 'iaso.payments.download_payments',
    },
    close: {
        id: 'iaso.label.close',
        defaultMessage: 'Close',
    },
    pending: {
        id: 'iaso.label.pending',
        defaultMessage: 'Pending',
    },
    changeStatus: {
        id: 'iaso.label.changeStatus',
        defaultMessage: 'Change status',
    },
    rejected: {
        id: 'iaso.label.rejected',
        defaultMessage: 'Rejected',
    },
    editPaymentFor: {
        id: 'iaso.payments.label.editPaymentFor',
        defaultMessage: 'Edit payment for {user}',
    },
    editSelected: {
        id: 'iaso.payments.label.editSelected',
        defaultMessage: 'Edit selected',
    },
    editSelectedPayments: {
        id: 'iaso.payments.label.editSelectedPayments',
        defaultMessage: 'Edit {count} selected payments',
    },
    confirm: {
        id: 'iaso.label.confirm',
        defaultMessage: 'Confirm',
    },
    confirmBulkChange: {
        id: 'iaso.payments.label.confirmBulkChange',
        defaultMessage: 'Confirm multiple changes',
    },
    bulkChangeCount: {
        id: 'iaso.payments.label.bulkChangeCount',
        defaultMessage: "You're about to update {count} payments",
    },
    paymentLotInfos: {
        id: 'iaso.payments.label.paymentLotInfos',
        defaultMessage: 'Payment lot informations',
    },
    paymentsBulkUpdateLaunched: {
        id: 'iaso.snackBar.paymentsBulkUpdateLaunched',
        defaultMessage:
            'The modifications to the payments will take a few moments to take effect',
    },
    unSelectAll: {
        id: 'iaso.payments.label.unSelectAll',
        defaultMessage: 'Unselect all',
    },
    selectAll: {
        id: 'iaso.payments.label.selectAll',
        defaultMessage: 'Select all',
    },
    phoneNumber: {
        id: 'iaso.label.phoneNumber',
        defaultMessage: 'Phone number',
    },
    viewChangeRequestsForUser: {
        id: 'iaso.label.viewChangeRequestsForUser',
        defaultMessage: 'View change requests for user',
    },
    viewChangeRequestforLot: {
        id: 'iaso.label.viewChangeRequestforLot',
        defaultMessage: 'View change requests for this payment lot',
    },
    viewChangeRequestsForPotentialPayment: {
        id: 'iaso.label.viewChangeRequestsForPotentialPayment',
        defaultMessage: 'View change requests for this potential payment',
    },
    viewChangeRequestsForPayment: {
        id: 'iaso.label.viewChangeRequestsForPayment',
        defaultMessage: 'View change requests for this payment',
    },
    paymentLotTaskLaunched: {
        id: 'iaso.snackBar.paymentLotTaskLaunched',
        defaultMessage:
            "The creation of the payment lot may take a few moments. Try refreshing the Payment Lots page if it doesn't appear",
    },
});

export default MESSAGES;
